export default __webpack_public_path__ + "fac0e82d4ad637c4306f1a1f7e754945.png";